import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { ComponentsModule } from 'src/app/components/components.module';
import { RedeemReffererCodeComponent } from './redeem-refferer-code.component';


@NgModule({
  declarations: [
    RedeemReffererCodeComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    ReactiveFormsModule,
    ComponentsModule,
  ]
})
export class RedeemReffererCodeModule { }